import { Link } from "react-router-dom";
import { H3, H3Spark, OfficialMark3 } from "./h3";
import { fmtPrice, fmtChange, changeColor } from "../tokens";
import { useV2Markets, useV2Sparks } from "../useV2Data";

/* Per-breakpoint approved border colors (214:262 / 205:100 / 206:104) */
const WATCH = [
  { sym: "BTC", name: "Bitcoin", cls: "border-[#ff8512] md:border-[#14e59e] xl:border-[#14d185]" },
  { sym: "ETH", name: "Ethereum", cls: "border-[#146ef2] xl:border-[#1f66f2]" },
  { sym: "SOL", name: "Solana", cls: "border-[#6e26ff] xl:border-[#a629f2]" },
];

/* Assets to Watch — Figma 214:262 (1440 3-across, heading inside first card
   top-left, VIEW ALL inside third) / 205:99 (768 stacked, heading outside) /
   206:103 (390 stacked). Real prices from the markets pipeline; sparklines
   are real Kraken hourly closes — omitted when the provider cannot supply. */
export const AssetsToWatch = () => {
  const { data: mkts } = useV2Markets();
  const { data: sp } = useV2Sparks();
  const coins: any[] = mkts?.coins || [];
  const cards = WATCH.map((w) => ({ ...w, coin: coins.find((c) => c.symbol === w.sym) })).filter((w) => w.coin);
  if (!cards.length) return null;
  return (
    <div data-testid="h3-assets-watch">
      <p className="xl:hidden nl-geist text-[13px] leading-[17px] font-bold mb-[10px]" style={{ color: H3.cyanTouch }}>
        ASSETS TO WATCH
      </p>
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-[10px] xl:gap-[18px]">
        {cards.map((w, i) => {
          const spark: number[] = sp?.sparks?.[w.sym] || [];
          const cc = changeColor(w.coin.change_24h);
          return (
            <div key={w.sym} data-testid={`h3-watch-${w.sym}`}
              className={`relative rounded-[9px] xl:rounded-[6px] border h-[104px] xl:h-[96px] min-[1440px]:h-[108px] px-[14px] xl:px-[16px] min-[1440px]:px-[18px] flex items-center gap-[14px] min-[1440px]:gap-[16px] ${w.cls}`}
              style={{ background: H3.card }}>
              {i === 0 && (
                <span className="hidden xl:block absolute top-[8px] left-[16px] nl-geist text-[10px] min-[1440px]:text-[11px] leading-[14px] font-bold"
                  style={{ color: H3.cyan }}>
                  ASSETS TO WATCH
                </span>
              )}
              <OfficialMark3 sym={w.sym} size={40} />
              <div className="min-w-0 w-[86px] min-[1440px]:w-[96px] shrink-0">
                <p className="nl-sg text-[17px] leading-[23px] font-bold" style={{ color: H3.text }}>{w.sym}</p>
                <p className="nl-geist text-[10px] leading-[14px]" style={{ color: H3.gray }}>{w.name}</p>
              </div>
              <div className="min-w-0 shrink-0">
                <p className="nl-sg text-[19px] xl:text-[18px] min-[1440px]:text-[20px] leading-[26px] font-bold" style={{ color: H3.text }}>
                  {fmtPrice(w.coin.price)}
                </p>
                <p className="nl-mono text-[10px] leading-[14px] font-bold" style={{ color: cc }}>
                  {fmtChange(w.coin.change_24h)}
                </p>
              </div>
              {spark.length >= 2 && (
                <span className="ml-auto shrink-0">
                  <span className="md:hidden"><H3Spark vals={spark} color={cc} w={62} h={12} sw={1.4} /></span>
                  <span className="hidden md:inline xl:hidden"><H3Spark vals={spark} color={cc} w={108} h={16} sw={1.5} /></span>
                  <span className="hidden xl:inline"><H3Spark vals={spark} color={cc} w={110} h={18} sw={1.6} /></span>
                </span>
              )}
              {i === cards.length - 1 && (
                <Link to="/markets" data-testid="h3-watch-viewall"
                  className="hidden xl:block absolute top-[8px] right-[16px] nl-mono text-[9px] leading-[13px] hover:opacity-80 transition-opacity"
                  style={{ color: H3.violetText }}>
                  VIEW ALL ASSETS →
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
